"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIconWrapper = exports.IconWrapper = exports.StrikeThroughText = exports.FilterText = exports.FilterTag = exports.Tag = exports.Text = void 0;
const native_1 = __importStar(require("styled-components/native"));
const TextStyle = native_1.css `
  color: ${(props) => props.theme.text.color.primary};
  text-align: center;
  padding: 4px 2%;
  font-size: ${(props) => props.theme.text.body.regular.size};
`;
const TagStyle = native_1.css `
  border-radius: 13.5px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
exports.Text = native_1.default.Text(({ theme, type }) => {
    return [
        TextStyle,
        native_1.css `
        color: ${theme.tags[`${type}`].text};
        font-size: 14px;
      `,
    ];
});
exports.Tag = native_1.default.View(({ theme, type }) => {
    return [
        TagStyle,
        native_1.css `
      background: ${theme.tags[`${type}`].background};
      font-size: 14px;
    `,
    ];
});
exports.FilterTag = native_1.default.TouchableOpacity `
  ${TagStyle}
  background: ${({ theme, type }) => theme.tags[`${type}`].background};
`;
exports.FilterText = native_1.default.Text `
  color: ${({ theme }) => theme.tags.filter.text};
  padding-right: 10px;
`;
exports.StrikeThroughText = native_1.default.Text `
  text-decoration-line: line-through;
  color: ${({ theme }) => theme.color.black};
  margin-left: 5px;
  font-size: ${({ theme }) => theme.text.body.regular.size};
`;
exports.IconWrapper = native_1.default.View `
  padding-left: 8px;
`;
exports.CloseIconWrapper = native_1.default.View `
  padding: 0 8px;
`;
